import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { color } from "style/constants";

const StyledLink = styled(
  ({ color, fontSize, bold, textDecoration, hoverStyle, ...otherProps }) => <Link {...otherProps} />
)`
  && {
    color: ${props => props.color || color.DARKBLUE};
    font-weight: ${props => (props.bold ? "700" : "normal")};
    ${props => props.fontSize && `font-size: ${props.fontSize};`}
    ${props => props.textDecoration && "text-decoration: underline;"}
    ${props =>
      props.hoverStyle &&
      `
      :hover {
        cursor: pointer;
        text-decoration: underline;
        color: black;
      }
    `}
  }
`;

export default StyledLink;
